import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
// import { PDFDownloadLink } from '@react-pdf/renderer';

// import ExtractPDF from '../ExtractPDF/ExtractPDF';
import css from './ExtractButton.module.css';

const ExtractButton = (props) => {
  const { className, bookingCompleted, income, intl, username, selectedYear } = props;
  const loadingText = intl.formatMessage({ id: 'IncomePage.generatingFile' });
  const buttonText = intl.formatMessage({ id: 'IncomePage.downloadAsPDF' });
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      {/*<PDFDownloadLink*/}
      {/*  className={css.PDFDownloadLink}*/}
      {/*  document={*/}
      {/*    <ExtractPDF*/}
      {/*      bookingCompleted={bookingCompleted}*/}
      {/*      intl={intl}*/}
      {/*      income={income}*/}
      {/*      username={username}*/}
      {/*      selectedYear={selectedYear}*/}
      {/*    />*/}
      {/*  }*/}
      {/*  fileName={`swimmy_declaration_${selectedYear}.pdf`}*/}
      {/*>*/}
      {/*  {({ blob, url, loading, error }) => (loading ? loadingText : buttonText)}*/}
      {/*</PDFDownloadLink>*/}
    </div>
  );
};

ExtractButton.defaultProps = {
  className: null,
};

ExtractButton.propTypes = {
  className: string,
  bookingCompleted: number.isRequired,
  income: string.isRequired,
  username: string.isRequired,
  selectedYear: number.isRequired,
};

export default ExtractButton;

// "@react-pdf/renderer": "3.1.14",
//   "@react-pdf/layout": "3.6.3",
